import React, { Component } from 'react';
import { adminservice } from '../../../services/admin.service';
import Loader from '../../../_helpers/Loader';

class UploadExcelFile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading:false,
            excelFormFile: null,
            studentClicked:false,
            errorMessage : "Please select a file to be uploaded.",
            excelNotAttached:false,
            filename:'',
            successMessage:false,
            message:'',
        };
    }

    componentDidMount=()=>{
        this.setState({studentClicked:this.props.studentClicked})
    }
    onExcelFileChange = e => {
        //check if file selected is a xls or xlsx file
        if (!this.isExcelFile(e.target.value)) {
          let randomString = Math.random().toString(36);
          this.setState({
            excelFileInputKey: randomString,
            excelFormFile: null,
            excelNotAttached: true,
          });
          return;
        }
    
        this.setState({
          excelNotAttached: false,
          excelFormFile: e.target.files[0],
          filename:e.target.value,
        });
    };

    isExcelFile = value => {
        //check if value is blank
        if (!value) return false;
    
        //regex to get file extension
        var re = /(?:\.([^.]+))?$/;
    
        //second item in the array will be the extension
        let ext = re.exec(value)[1];
        const validFormats = this.getValidFormats();
    
        if (validFormats.some(format => format === ext)) return true;
        else return false;
    };

    getValidFormats =() => {
        return ['xlsx', 'xls', 'csv'];
    }

    handleExcelFormSubmit=async()=>{
        if (!this.state.excelFormFile) {
            this.setState({ excelNotAttached: true });
            return;
        }
        this.setState({isLoading:true});
        var page = this.state.studentClicked?"RegisterStudent":"RegisterMember";
        let data=new FormData();
        data.append('excelFile', this.state.excelFormFile);
        data.append('excelSheetName',page);
        
        var response = await adminservice.UploadExcelSheet(data);
        if(response.status === 200){
            if(response.data.includes("New Members:")){
                this.setState({
                    successMessage:true,
                    message:response.data
                })
                this.props.closeSuccessModel();
            }else{
                this.setState({
                    errorMessage:response.data,
                    excelNotAttached:true,
                    filename:'',
                })
            }
        }

        this.setState({isLoading:false});

    }

    closePopUpModel=()=>{
        this.props.closeModel();
    }
    render() {
        const{
            studentClicked,
            excelNotAttached,
            errorMessage,
            isLoading,
            filename,
            successMessage,
            message,
        }=this.state;
        return (
            <div className="modal update-unit-popup" id="myModal">
            {isLoading && <Loader />}
            <div style={{top:"calc(84vh - 50%)"}} className="modal-dialog" >
                <div className="modal-content">
                {/* Modal Header */}
                <div className="modal-header" style={{padding:'9px 1rem'}}>
                    <h4 className="modal-title">{studentClicked?"Upload Student":"Upload Member"}</h4>
                    <button type="button" onClick={()=>this.closePopUpModel()} className="btn-close">X</button>
                </div>
                {/* Modal body */}
                <div className="modal-body">
                    <input 
                        type="file" 
                        accept=".xlsx, .xls"
                        onChange={this.onExcelFileChange}
                        name="excelFile"
                        value={filename}
                    />
                </div>
                {excelNotAttached?
                    <div className="error-message col-5 col-md-5" style={{ display: "contents",color: "red" }}>
                    <div style={{paddingLeft:"13px",marginTop:'-5px'}}>{errorMessage}</div>
                    </div>
                :""}
                {studentClicked && successMessage ? 
                    <div className="error-message col-5 col-md-5" style={{ display: "contents",color: "green" }}>
                    <div style={{paddingLeft:"13px",marginTop:'-5px'}}> Students have been uploaded Successfully. {message}</div>
                    </div>
                :""}
                {!studentClicked && successMessage ? 
                    <div className="error-message col-5 col-md-5" style={{ display: "contents",color: "green" }}>
                    <div style={{paddingLeft:"13px",marginTop:'-5px'}}><p>Members have been uploaded Successfully. </p>{message}</div>
                    </div>
                :""}
                {/* Modal footer */}
                <div className="modal-footer" style={{padding:'6px 1rem'}}>
                    <button type="button" onClick={()=>this.handleExcelFormSubmit()} className="btn Submit-btn">Upload</button>
                    <button type="submit" onClick={()=>this.closePopUpModel()} className="btn Cancel-btn">Cancel</button>
                </div>
            </div>
            </div>
            </div>
        );
    }
}

export default UploadExcelFile;